import { Component, OnInit, ElementRef, ViewChild, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PhotoModalComponent } from '../../common-components/photo-modal/photo-modal.component';
import { ExcelService } from './../../../../../../../src/test/service/excel.service';
import { FilterService } from '../side-filter/filter.service';
import { FilterForProduct } from '../data-source/product-data-source';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ProductServiceProxy } from './../../../../../../shared/service-proxies/service-proxies';
import { saveAs } from 'file-saver';
import { FileService } from './../../shared/services/file.service';
import { AppComponentBase } from '@shared/app-component-base';
import { AlertType } from '@shared/helpers/UIMessage';

@Component({
  selector: 'kt-product-search-bar',
  templateUrl: './product-search-bar.component.html',
  styleUrls: ['./product-search-bar.component.scss']
})
export class ProductSearchBarComponent extends AppComponentBase implements OnInit {

  searchedKeywords: string;

  private subscriptions: Subscription[] = [];

  @ViewChild('productSearchInput', { static: true }) searchInput: ElementRef;

  constructor(
    injector : Injector,
    private modalService: NgbModal,
    private _excelService: ExcelService,
    public _filterService: FilterService,
    private _productService: ProductServiceProxy,
    private _fileService: FileService

  ) { 
    super(injector);
  }

  ngOnInit() {

    const searchSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      debounceTime(600),
      distinctUntilChanged(),
      tap(() => {
        console.log(this.searchedKeywords);
        if (this._filterService.filterParams.keyword != this.searchedKeywords) {

          this._filterService.filterParams.keyword = this.searchedKeywords;

          this._filterService.resetPageNumber$.next(true);

          this._filterService.loadProductList();
        }
      })
    ).subscribe();

    this.subscriptions.push(searchSubscription);
  }

  onExportToExcelLite() {

    this._filterService.productsForExcel$.subscribe(result2 => {
      this._excelService.exportAsExcelFile(result2.items, "Test.xlsx", result2.columns);
    }).unsubscribe();


    this._filterService.loadDataForExcel();
  }

  onExportToExcelLite2(isWithPhoto : boolean, isSubWarehouse :boolean) {

    this.exportExcel(isWithPhoto, isSubWarehouse) ;

    

	 
  }

  exportExcel(isWithPhoto, isSubWarehouse){
     //this._productService.getWarehousesProductStockListByUserAuthsToExcel([], [], [], this._filterService.filterParams.warehouses,'', '', 0, 10 ,isWithPhoto)
	  this._productService.getWarehousesProductStockListByUserAuthsToExcel(this._filterService.filterParams.brands, this._filterService.filterParams.productTypes, this._filterService.filterParams.businessUnits, this._filterService.filterParams.warehouses, '', '', 0, 1000, isWithPhoto, isSubWarehouse)
    .subscribe(res => {
    
      /*
      var blob = this._fileService.base64toBlob(res.base64, res.fileType);
      const file = new File([blob], res.fileName, { type: res.fileType });

      saveAs(file);
      */

      //22.02.2024 tarihinde backgroundJob kullanilarak, aktif kullanicinin mail adresine dosya gonderilmektedir.
     
      const message = "Stok raporu hazırlanıyor, " + this.appSession.user.emailAddress + " adresine birazdan gönderilecek."
      this.uiMessage.modal.success("OK", message, null);

    });
  }

  onSort(sort: string) {
    this._filterService.filterParams.sorting = sort;
    this._filterService.loadProductList();
  }

  onTest() {

  }

 
}
